import * as fromApplication from '../reducers/applicationReducers'

export const getApplication = (state) => fromApplication.getApplication(state.application);
export const getApplicationList = (state) => fromApplication.getApplicationList(state.application);
export const getApplicationData = (state) => fromApplication.getApplicationData(state.application);
export const getApplicationRequest = (state) => fromApplication.getApplicationRequest(state.application);
export const getApplicationPagination = (state) => fromApplication.getApplicationPagination(state.application);
export const getApplicationCountByStatus = (state) => fromApplication.getApplicationCountByStatus(state.application);
